import React from 'react';
type UtilityHeroProps = {
  titleId: string;
  title: string;
  subtitle?: string;
  /** Optional oversized marker above the title, such as "404". */
  display?: string;
  children?: React.ReactNode;
};

/** Shared centered page header used by What's new, 404, and confirmation pages. */
export function UtilityHero({
  titleId,
  title,
  subtitle,
  display,
  children
}: UtilityHeroProps) {
  return <div className="mx-auto max-w-[680px] text-center" data-id="element-1691" data-mp="1ez60xrvopc1n">
      {display && <p aria-hidden="true" className="display text-[96px] font-semibold leading-none text-brand sm:text-[132px]" data-id="element-1692" data-mp="1j1arghqu5sk2">
          {display}
        </p>}
      <h1 id={titleId} className={`display font-semibold text-ink ${display ? 'mt-6 text-[30px] sm:text-[40px]' : 'text-[38px] sm:text-[50px] lg:text-[56px]'}`} data-id="element-1693" data-mp="150qbdtcb2au9">
        {title}
      </h1>
      {subtitle && <p className="mx-auto mt-5 max-w-[520px] text-[18px] leading-[1.5] text-ink-muted" data-id="element-1694" data-mp="3pttr1a60xxsa">{subtitle}</p>}
      {children}
    </div>;
}